import { useNavigate } from 'react-router-dom';
import { ArrowRight, Package, Plus, Zap } from 'lucide-react';
import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';

interface ClientConnectorsProps {
  clientId: string;
}

export function ClientConnectors({ clientId: _clientId }: ClientConnectorsProps) {
  const navigate = useNavigate();

  // Fetch installed BoBs
  const { data: installed } = useQuery({
    queryKey: ['installed-bobs'],
    queryFn: () => api.getInstalledBoBs(),
  });

  const installedCount = installed?.bobs?.length || 0;

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-2xl font-bold text-slate-100">Connectors & BoBs</h2>
          <p className="mt-1 text-sm text-slate-400">Manage your AIIA integration and installed BoBs</p>
        </div>
        <button
          onClick={() => navigate('/bobs')}
          className="inline-flex items-center px-4 py-2 border border-transparent rounded-lg shadow-sm text-sm font-medium text-white bg-gradient-to-r from-blue-600 to-blue-500 hover:from-blue-700 hover:to-blue-600 transition-all"
        >
          <Plus className="h-4 w-4 mr-2" />
          Install BoBs
        </button>
      </div>

      {/* Status Card */}
      <div className="bg-gradient-to-br from-blue-500/10 to-emerald-500/10 border border-blue-500/30 rounded-lg p-6">
        <div className="flex items-center gap-4">
          <div className="w-12 h-12 rounded-full bg-blue-500/20 flex items-center justify-center">
            <Package className="w-6 h-6 text-blue-400" />
          </div>
          <div className="flex-1">
            <h3 className="text-lg font-semibold text-slate-100">AIIA Connector</h3>
            <p className="text-sm text-slate-400">
              {installedCount > 0
                ? `${installedCount} BoB${installedCount !== 1 ? 's' : ''} installed and ready`
                : 'No BoBs installed yet'}
            </p>
          </div>
          <button
            onClick={() => navigate('/bobs')}
            className="flex items-center gap-2 px-4 py-2 rounded-lg bg-slate-800/50 border border-slate-700 text-slate-300 hover:bg-slate-800 transition-colors"
          >
            Manage
            <ArrowRight className="w-4 h-4" />
          </button>
        </div>
      </div>

      {/* Quick Actions */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <button
          onClick={() => navigate('/bobs')}
          className="p-6 rounded-lg bg-slate-800/50 border border-slate-700 hover:border-slate-600 transition-colors text-left"
        >
          <Zap className="w-8 h-8 text-amber-400 mb-3" />
          <h4 className="font-semibold text-slate-100">Browse BoB Marketplace</h4>
          <p className="text-sm text-slate-400 mt-1">
            Discover and install Business Operation Bots for your Odoo
          </p>
        </button>
        <button
          onClick={() => navigate('/bobs')}
          className="p-6 rounded-lg bg-slate-800/50 border border-slate-700 hover:border-slate-600 transition-colors text-left"
        >
          <Package className="w-8 h-8 text-blue-400 mb-3" />
          <h4 className="font-semibold text-slate-100">Configure API Key</h4>
          <p className="text-sm text-slate-400 mt-1">
            Generate or manage your AIIA API key for Odoo integration
          </p>
        </button>
      </div>
    </div>
  );
}
